export default __webpack_public_path__ + "static/media/cake.65544730.png";